(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bp-studio-customizer"] && !Shopify.designMode) return;
  try {
    const bootStudioEditors = (scope = document) => {
const editors = [...scope.querySelectorAll('[data-bp-studio-editor]')];
if (scope.matches?.('[data-bp-studio-editor]')) editors.unshift(scope);
editors.forEach((editor) => {
  if (editor.dataset.studioMounted === 'true') return;
  editor.dataset.studioMounted = 'true';
  const form = editor.closest('form');
  const select = form?.querySelector('[data-variant-select]');
  const buttons = [...editor.querySelectorAll('[data-bp-studio-preset]')];
  const fields = Object.fromEntries([...editor.querySelectorAll('[data-bp-studio-color]')].map((input) => [input.dataset.bpStudioColor, input]));
  const presetField = editor.querySelector('[data-bp-studio-preset-value]');
  const logo = editor.querySelector('[data-bp-studio-logo]');
  const name = editor.querySelector('[data-bp-studio-logo-name]');
  const model = editor.querySelector('select[name="properties[Model and trim]"]');
  const otherModelWrap = editor.querySelector('[data-bp-studio-other-model]');
  const otherModel = otherModelWrap?.querySelector('input');
  const syncOtherModel = () => {
    const enabled = model?.value === 'Other';
    if (otherModelWrap) otherModelWrap.hidden = !enabled;
    if (otherModel) {
      otherModel.disabled = !enabled;
      otherModel.required = enabled;
      if (!enabled) otherModel.value = '';
    }
  };
  const sync = (resetColors) => {
    const selected = select?.selectedOptions[0]?.dataset.color || buttons[0]?.dataset.bpStudioPreset;
    const active = buttons.find((button) => button.dataset.bpStudioPreset.toLowerCase() === String(selected).toLowerCase());
    buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === active)));
    if (active && resetColors) {
      for (const channel of ['primary','secondary','accent']) {
        const color = active.dataset[channel];
        if (fields[channel] && /^#[0-9a-f]{6}$/i.test(color)) fields[channel].value = color;
      }
    }
    if (presetField) presetField.value = active?.dataset.bpStudioPreset || String(selected || '');
  };
  buttons.forEach((button) => button.addEventListener('click', () => {
    if (!select) return;
    const option = [...select.options].find((item) => item.dataset.color.toLowerCase() === button.dataset.bpStudioPreset.toLowerCase());
    if (!option || option.disabled) return;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles:true }));
  }));
  select?.addEventListener('change', () => sync(true));
  model?.addEventListener('change', syncOtherModel);
  logo?.addEventListener('change', () => { if (name) name.textContent = logo.files?.[0]?.name || ''; });
  syncOtherModel();
  sync(true);
});
};
bootStudioEditors();
document.addEventListener('shopify:section:load', event => bootStudioEditors(event.target));
window.addEventListener('pageshow', () => bootStudioEditors());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["checkpoint-20261020-2240-bp-studio-customizer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-bp-studio-editor]').forEach((editor) => {
  const form = editor.closest('form');
  const select = form?.querySelector('[data-variant-select]');
  const buttons = [...editor.querySelectorAll('[data-bp-studio-preset]')];
  const fields = Object.fromEntries([...editor.querySelectorAll('[data-bp-studio-color]')].map((input) => [input.dataset.bpStudioColor, input]));
  const presetField = editor.querySelector('[data-bp-studio-preset-value]');
  const logo = editor.querySelector('[data-bp-studio-logo]');
  const name = editor.querySelector('[data-bp-studio-logo-name]');
  const model = editor.querySelector('select[name="properties[Model and trim]"]');
  const otherModelWrap = editor.querySelector('[data-bp-studio-other-model]');
  const otherModel = otherModelWrap?.querySelector('input');
  const syncOtherModel = () => {
    const enabled = model?.value === 'Other';
    if (otherModelWrap) otherModelWrap.hidden = !enabled;
    if (otherModel) {
      otherModel.disabled = !enabled;
      otherModel.required = enabled;
      if (!enabled) otherModel.value = '';
    }
  };
  const sync = (resetColors) => {
    const selected = select?.selectedOptions[0]?.dataset.color || buttons[0]?.dataset.bpStudioPreset;
    const active = buttons.find((button) => button.dataset.bpStudioPreset.toLowerCase() === String(selected).toLowerCase());
    buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === active)));
    if (active && resetColors) {
      for (const channel of ['primary','secondary','accent']) {
        const color = active.dataset[channel];
        if (fields[channel] && /^#[0-9a-f]{6}$/i.test(color)) fields[channel].value = color;
      }
    }
    if (presetField) presetField.value = active?.dataset.bpStudioPreset || String(selected || '');
  };
  buttons.forEach((button) => button.addEventListener('click', () => {
    if (!select) return;
    const option = [...select.options].find((item) => item.dataset.color.toLowerCase() === button.dataset.bpStudioPreset.toLowerCase());
    if (!option || option.disabled) return;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles:true }));
  }));
  select?.addEventListener('change', () => sync(true));
  model?.addEventListener('change', syncOtherModel);
  logo?.addEventListener('change', () => { if (name) name.textContent = logo.files?.[0]?.name || ''; });
  syncOtherModel();
  sync(true);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["checkpoint-20261020-2240-snow-older-model-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const unique = values => [...new Set(values)];
    const option = (value, label) => {
      const element = document.createElement('option');
      element.value = String(value);
      element.textContent = label;
      return element;
    };
    document.querySelectorAll('[data-bp-older-picker]').forEach(async root => {
      const form = root.querySelector('[data-bp-older-form]');
      const makeSelect = root.querySelector('[data-bp-older-make]');
      const year = root.querySelector('[data-bp-older-year]');
      const model = root.querySelector('[data-bp-older-model]');
      const track = root.querySelector('[data-bp-older-track]');
      const trackField = root.querySelector('[data-bp-older-track-field]');
      const request = root.querySelector('[data-request-form]');
      const selectionSummary = root.querySelector('[data-selection-summary]');
      const contactFields = Object.fromEntries([...root.querySelectorAll('[data-contact-field]')].map(input => [input.dataset.contactField,input]));
      const upload = root.querySelector('[data-request-upload]');
      const uploadName = root.querySelector('[data-upload-name]');
      const status = root.querySelector('[data-bp-older-status]');
      const script = root.querySelector('[data-machine-data]');
      const modernDesigns = JSON.parse(root.querySelector('[data-modern-designs]')?.textContent || '[]');
      const collator = new Intl.Collator(document.documentElement.lang || 'en', { numeric:true, sensitivity:'base' });
      const placeholders = { year:year.options[0].textContent, model:model.options[0].textContent, track:track.options[0].textContent };
      let catalog, makeIndex, categoryIndex, categoryRows = [], makeRows = [], restoring = false, lookupSerial = 0;
      const invalidateLookup = () => {
        lookupSerial += 1;
        root.removeAttribute('aria-busy');
      };
      const fill = (select, placeholder, entries) => {
        select.replaceChildren(option('', placeholder));
        entries.forEach(([value,label]) => select.append(option(value,label)));
        select.disabled = !entries.length;
        select.value = '';
      };
      const rowTrackSize = row => {
        const label = catalog.trims[row[4]] || '';
        const match = label.match(/(?:^|[^\d])(1[2-8]\d)\s*(?:"|″|''|in(?:ches)?\b)/i);
        return match ? match[1] : null;
      };
      const productTrackSize = handle => {
        const match = handle.match(/(?:tunnel|track)[-_ ]?(1[2-8]\d)(?:\b|$)|\b(1[2-8]\d)[-_ ]?(?:tunnel|track)(?:\b|$)/i);
        return match ? (match[1] || match[2]) : null;
      };
      const matchingRows = () => makeRows.filter(row => row[2] === year.value && row[3] === Number(model.value));
      const trackSizes = () => unique(matchingRows().filter(row => row[5].length).flatMap(row => {
        const size = rowTrackSize(row);
        return size ? [size] : row[5].map(index => productTrackSize(catalog.products[index])).filter(Boolean);
      })).sort((a,b) => Number(a)-Number(b));
      const matchHandles = () => {
        const rows = matchingRows().filter(row => !track.value || !rowTrackSize(row) || rowTrackSize(row) === track.value);
        return unique(rows.flatMap(row => row[5])).filter(index => {
          const size = productTrackSize(catalog.products[index]);
          return !track.value || !size || size === track.value;
        }).map(index => catalog.products[index]).filter(handle => !(catalog.modern_products || []).includes(handle));
      };
      const resetTrack = () => {
        fill(track, placeholders.track, []);
        track.required = false;
        trackField.hidden = true;
      };
      const hideRequest = () => {
        if (!request.querySelector('.machine-finder__form-message')) request.hidden = true;
      };
      const vintageOnly = root.dataset.vintageOnly === 'true';
      const selectedMake = () => catalog.makes[makeIndex] || root.dataset.olderMake || '';
      const selectedCategory = () => root.dataset.olderCategoryLabel || catalog.categories[categoryIndex].label;
      const selectedModel = () => model.value === 'not-listed' ? root.dataset.unlisted : catalog.models[Number(model.value)];
      const showRequest = () => {
        const values = {
          category:selectedCategory(),
          make:selectedMake(),
          year:year.value,
          model:selectedModel(),
          track:track.value && track.value !== 'not-sure' ? track.value + '″' : ''
        };
        Object.entries(values).forEach(([key,value]) => {
          if (contactFields[key]) contactFields[key].value = value;
        });
        selectionSummary.textContent = Object.values(values).filter(Boolean).join(' / ');
        request.hidden = false;
        status.textContent = root.dataset.noMatch;
        if (!restoring) request.scrollIntoView({behavior:'smooth',block:'nearest'});
      };
      const navigate = async () => {
        if (restoring || !year.value || !model.value || (model.value !== 'not-listed' && !trackField.hidden && !track.value)) return;
        if (model.value === 'not-listed') {
          showRequest();
          return;
        }
        const lookup = ++lookupSerial;
        root.setAttribute('aria-busy','true');
        status.textContent = root.dataset.matchesLoading;
        const fitment = await window.BPSnowFitmentReady?.catch(() => null);
        if (lookup !== lookupSerial) return;
        const modern = root.dataset.olderCategory === 'snowmobile' && !vintageOnly
          ? fitment?.matchDesigns(modernDesigns, selectedMake(), year.value, selectedModel(), trackField.hidden ? '' : track.value) || { handles: [], model: '' }
          : { handles: [], model: '' };
        const handles = unique([...modern.handles, ...matchHandles()]);
        if (!handles.length) {
          root.removeAttribute('aria-busy');
          showRequest();
          return;
        }
        const base = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
        const checked = await Promise.allSettled(handles.map(async handle => {
          const response = await fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { headers:{ Accept:'application/json' } });
          if (response.status === 404) return null;
          if (!response.ok) throw new Error('Product lookup unavailable');
          const product = await response.json();
          const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
          const unpreparedTemplate = root.dataset.olderCategory === 'snowmobile' && Number(year.value) < 2011
            && tags.some(tag => tag.trim().toLowerCase() === 'template-purchasable');
          const verifiedVintage = !vintageOnly || tags.some(tag => tag.trim().toLowerCase() === 'vintage');
          return product.handle === handle && !unpreparedTemplate && verifiedVintage ? handle : null;
        }));
        if (lookup !== lookupSerial) return;
        root.removeAttribute('aria-busy');
        const available = checked.filter(item => item.status === 'fulfilled' && item.value).map(item => item.value);
        if (!available.length) {
          if (checked.some(item => item.status === 'rejected')) status.textContent = root.dataset.checkError;
          else showRequest();
          return;
        }
        const params = new URLSearchParams({
          category:selectedCategory(),
          category_key:root.dataset.olderCategory,
          make:selectedMake(),
          year:year.value,
          model:selectedModel(),
          track_size:trackField.hidden ? '' : track.value,
          products:available.join(','),
          source:root.dataset.olderCategory === 'snowmobile' && !modern.handles.length ? 'older' : 'collection',
          source_collection:root.dataset.sourceCollection
        });
        if (modern.handles.length && modern.model) params.set('modern_model', modern.model);
        const previewId = new URLSearchParams(location.search).get('preview_theme_id');
        if (previewId) params.set('preview_theme_id',previewId);
        location.assign(root.dataset.resultsUrl + '?' + params.toString());
      };
      const populateYears = () => {
        makeRows = categoryRows.filter(row => row[1] === makeIndex);
        const availableRows = makeRows.length || makeSelect ? makeRows : categoryRows;
        const years = unique(availableRows.map(row => row[2])).sort((a,b) => {
          if (a === 'Current') return -1;
          if (b === 'Current') return 1;
          return Number(b)-Number(a);
        });
        fill(year, placeholders.year, years.map(value => [value,value]));
        fill(model, placeholders.model, []);
        resetTrack();
        hideRequest();
        status.textContent = '';
        return years;
      };
      if (makeSelect) makeSelect.addEventListener('change', () => {
        invalidateLookup();
        makeIndex = makeSelect.value === '' ? -1 : Number(makeSelect.value);
        populateYears();
      });
      year.addEventListener('change', () => {
        invalidateLookup();
        fill(model, placeholders.model, []);
        resetTrack();
        hideRequest();
        status.textContent = '';
        if (year.value) {
          const indexes = unique(makeRows.filter(row => row[2] === year.value).map(row => row[3]))
            .sort((a,b) => collator.compare(catalog.models[a],catalog.models[b]));
          fill(model, placeholders.model, indexes.map(index => [index,catalog.models[index]]).concat([['not-listed',root.dataset.unlisted]]));
        }
      });
      model.addEventListener('change', () => {
        invalidateLookup();
        resetTrack();
        hideRequest();
        status.textContent = '';
        if (!model.value) return;
        if (model.value === 'not-listed') {
          showRequest();
          if (!restoring) root.querySelector('[name="contact[Unlisted model]"]')?.focus({preventScroll:true});
          return;
        }
        const sizes = trackSizes();
        if (sizes.length) {
          fill(track, placeholders.track, sizes.map(size => [size,size + '″']));
          track.required = true;
          trackField.hidden = false;
        } else navigate();
      });
      track.addEventListener('change', () => {
        invalidateLookup();
        hideRequest();
        if (model.value !== 'not-listed' && track.value) navigate();
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (form.reportValidity()) navigate();
      });
      try {
        if (!('DecompressionStream' in window)) throw new Error('Catalog decompression unavailable');
        const binary = atob(script.textContent.trim());
        const bytes = Uint8Array.from(binary, character => character.charCodeAt(0));
        catalog = JSON.parse(await new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'))).text());
        categoryIndex = catalog.categories.findIndex(item => item.key === root.dataset.olderCategory);
        if (categoryIndex < 0) throw new Error('Category unavailable');
        categoryRows = catalog.rows.filter(row => row[0] === categoryIndex);
        makeIndex = catalog.makes.indexOf(root.dataset.olderMake);
        if (makeSelect) {
          const indexes = unique(categoryRows.map(row => row[1]))
            .filter(index => catalog.makes[index] !== 'Digital Product')
            .sort((a,b) => collator.compare(catalog.makes[a],catalog.makes[b]));
          fill(makeSelect, makeSelect.options[0].textContent, indexes.map(index => [index,catalog.makes[index]]));
        }
        const saved = new URLSearchParams(location.search);
        const savedMake = saved.get('finder_make');
        if (makeSelect && savedMake) {
          const index = catalog.makes.indexOf(savedMake);
          if ([...makeSelect.options].some(item => item.value === String(index))) {
            makeSelect.value = String(index);
            makeIndex = index;
          }
        }
        const years = populateYears();
        const savedYear = saved.get('finder_year');
        if (years.includes(savedYear)) {
          restoring = true;
          year.value = savedYear;
          year.dispatchEvent(new Event('change'));
          const index = catalog.models.findIndex(value => value === saved.get('finder_model'));
          const savedModel = saved.get('finder_model');
          if (index >= 0 && [...model.options].some(item => item.value === String(index))) {
            model.value = String(index);
            model.dispatchEvent(new Event('change'));
          } else if (savedModel) {
            model.value = 'not-listed';
            root.querySelector('[name="contact[Unlisted model]"]').value = savedModel;
            model.dispatchEvent(new Event('change'));
          }
          const savedTrack = saved.get('finder_track_size');
          if ([...track.options].some(item => item.value === savedTrack)) track.value = savedTrack;
          restoring = false;
        }
        if (upload) upload.addEventListener('change', () => {
          const file = upload.files?.[0];
          if (!file) { uploadName.textContent = ''; return; }
          if (file.size > 10 * 1024 * 1024) {
            upload.value = '';
            uploadName.textContent = root.dataset.uploadTooLarge;
            return;
          }
          uploadName.textContent = file.name;
        });
      } catch (error) {
        status.textContent = root.dataset.catalogError;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["checkpoint-20261020-2240-sxs-make-navigation"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sxs-picker]').forEach(root => {
  const form = root.querySelector('[data-sxs-form]');
  const year = root.querySelector('[data-sxs-year]');
  const model = root.querySelector('[data-sxs-model]');
  const status = root.querySelector('[data-sxs-status]');
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const selected = model.selectedOptions[0];
    if (selected.dataset.url) {
      location.href = selected.dataset.url + '?finder_year=' + encodeURIComponent(year.value) + '&finder_model=' + encodeURIComponent(model.value);
    } else {
      status.textContent = 'Tell us your model on the contact page and we’ll confirm fitment before production.';
      location.href = '/pages/contact?subject=' + encodeURIComponent('SXS graphics request: ' + year.value + ' model not listed');
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-scripts"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  const customizerMoney = (root, cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
    style: 'currency',
    currency: root.dataset.currency || 'CAD'
  }).format(Number(cents || 0) / 100);

  const customizerBasePrice = (form) => {
    const variantSelect = form.querySelector('[data-variant-select]');
    if (variantSelect) return Number(variantSelect.selectedOptions[0]?.dataset.priceCents || 0);
    return Number(form.querySelector('[data-base-variant]')?.dataset.priceCents || 0);
  };

  const customizerAddons = (form) => {
    const selected = [...form.querySelectorAll('[data-addon-id]:checked')].map((input) => ({
      id: Number(input.dataset.addonId),
      price: Number(input.dataset.addonPrice || 0),
      label: input.dataset.addonLabel || input.value
    }));
    const coverage = form.querySelector('[data-coverage-choice]:checked');
    if (coverage) {
      const bikeSize = form.querySelector('[data-bike-size]:checked')?.dataset.bikeSize || 'big';
      selected.push({
        id: Number(coverage.dataset[bikeSize + 'AddonId']),
        price: Number(coverage.dataset[bikeSize + 'Price'] || 0),
        label: coverage.dataset.addonLabel || coverage.value
      });
    }
    return selected.filter((item) => item.id);
  };

  const updateCustomizer = (form) => {
    const root = form.closest('[data-product-root]');
    if (!root || !form.querySelector('.bp-customizer')) return;
    const bikeSize = form.querySelector('[data-bike-size]:checked')?.dataset.bikeSize || 'big';
    form.querySelectorAll('[data-coverage-choice]').forEach((input) => {
      const price = Number(input.dataset[bikeSize + 'Price'] || 0);
      const label = input.parentElement.querySelector('[data-coverage-price]');
      if (label) label.textContent = '+ ' + customizerMoney(root, price);
    });
    const addition = customizerAddons(form).reduce((total, item) => total + item.price, 0);
    const total = customizerBasePrice(form) + addition;
    const additions = form.querySelector('[data-customizer-additions]');
    const configured = form.querySelector('[data-configured-total]');
    const productPrice = root.querySelector('[data-product-price]');
    if (additions) additions.textContent = customizerMoney(root, addition);
    if (configured) configured.textContent = customizerMoney(root, total);
    if (productPrice) productPrice.textContent = customizerMoney(root, total);
  };

  const clearMissingField = (form) => {
    form.querySelectorAll('.bp-field-missing').forEach((group) => group.classList.remove('bp-field-missing'));
    form.querySelectorAll('.bp-field-hint').forEach((hint) => hint.remove());
    form.querySelectorAll('[aria-invalid="true"]').forEach((field) => field.removeAttribute('aria-invalid'));
    const error = form.querySelector('[data-customizer-error]');
    if (error && (error.dataset.status === 'missing' || error.dataset.status === 'success')) {
      error.hidden = true;
      delete error.dataset.status;
    }
  };

  const showMissingField = (form) => {
    const field = [...form.elements].find((element) => element.willValidate && !element.validity.valid);
    if (!field) return false;
    clearMissingField(form);
    const group = field.closest('fieldset') || field.closest('.product-form__group') || field.parentElement;
    const label = field.closest('fieldset')?.querySelector('legend')?.textContent?.trim()
      || field.labels?.[0]?.textContent?.trim()
      || field.name.replace(/^properties\[|\]$/g, '');
    const message = `Complete ${label} before adding to cart.`;
    const error = form.querySelector('[data-customizer-error]');
    if (error) {
      error.textContent = message;
      error.dataset.status = 'missing';
      error.hidden = false;
    }
    if (group) {
      group.classList.add('bp-field-missing');
      const hint = document.createElement('p');
      hint.className = 'bp-field-hint';
      hint.textContent = message;
      hint.setAttribute('role', 'alert');
      group.appendChild(hint);
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    field.setAttribute('aria-invalid', 'true');
    field.focus({ preventScroll: true });
    return true;
  };

  document.querySelectorAll('[data-priced-customizer]').forEach((form) => {
    const productRoot = form.closest('[data-product-root]');
    const visualizerKey = 'sled-visualizer:' + window.location.pathname;
    const visualizerLink = productRoot?.querySelector('[data-sled-visualizer-link]');
    if (visualizerLink) {
      visualizerLink.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const selections = [...form.elements].filter((field) => field.name && field.type !== 'file' && field.type !== 'submit').map((field) => ({
          name: field.name, value: field.value, checked: field.checked, type: field.type
        }));
        try {
          sessionStorage.setItem(visualizerKey, JSON.stringify({
            selections, hadFile: Boolean(form.querySelector('[data-customizer-upload]')?.files?.length)
          }));
        } catch (_) { /* Navigation still works if browser storage is unavailable. */ }
        const destination = new URL(visualizerLink.href);
        const variant = form.querySelector('[name="id"]')?.value;
        if (variant) destination.searchParams.set('variant', variant);
        event.preventDefault();
        window.location.assign(destination.href);
      });
    }
    if (productRoot?.dataset.printBuilder) {
      try {
        const saved = JSON.parse(sessionStorage.getItem(visualizerKey) || 'null');
        if (saved) {
          for (const choice of saved.selections || []) {
            const field = [...form.elements].find((element) => element.name === choice.name && (
              choice.type !== 'checkbox' && choice.type !== 'radio' || element.value === choice.value
            ));
            if (!field) continue;
            if (choice.type === 'checkbox' || choice.type === 'radio') field.checked = choice.checked;
            else field.value = choice.value;
          }
          if (saved.hadFile) {
            const status = form.querySelector('[data-sled-status]');
            if (status) status.textContent = 'Please attach your logo or artwork again below. File uploads cannot move between pages.';
          }
          sessionStorage.removeItem(visualizerKey);
        }
      } catch (_) { /* Form remains usable without stored selections. */ }
    }
    updateCustomizer(form);

    let checkingByClick = false;
    let pendingInvalid = false;
    form.addEventListener('click', (event) => {
      const button = event.target.closest('[data-add-button]');
      if (!button || !form.contains(button)) return;
      checkingByClick = true;
      const valid = form.checkValidity();
      checkingByClick = false;
      if (!valid) {
        event.preventDefault();
        showMissingField(form);
      }
    });
    form.addEventListener('invalid', () => {
      if (checkingByClick || pendingInvalid) return;
      pendingInvalid = true;
      requestAnimationFrame(() => {
        pendingInvalid = false;
        showMissingField(form);
      });
    }, true);

    form.addEventListener('change', () => {
      updateCustomizer(form);
      clearMissingField(form);
    });
    form.addEventListener('input', (event) => {
      if (event.target.matches('[data-bike-size], [data-coverage-choice], [data-addon-id]')) updateCustomizer(form);
      if (event.target.validity?.valid) clearMissingField(form);
    });

    const upload = form.querySelector('[data-customizer-upload]');
    if (upload) {
      upload.addEventListener('change', () => {
        const output = form.querySelector('[data-upload-file-name]');
        if (output) output.textContent = upload.files?.[0]?.name || '';
      });
    }

    form.addEventListener('submit', async (event) => {
      const root = form.closest('[data-product-root]');
      const isPreview = root?.dataset.previewOnly === 'true';
      const isCartPreview = root?.dataset.cartPreview === 'true';
      if (!isPreview && !form.querySelector('.bp-customizer, [data-sled-builder]')) return;
      event.preventDefault();
      if (!form.checkValidity()) {
        showMissingField(form);
        return;
      }
      clearMissingField(form);
      const button = form.querySelector('[data-add-button]');
      const error = form.querySelector('[data-customizer-error]');
      if (isPreview && !isCartPreview) {
        if (error) {
          error.textContent = 'All required options are complete. This preview cannot be added to cart until pricing and artwork are approved.';
          error.dataset.status = 'success';
          error.hidden = false;
          error.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        return;
      }
      const formData = new FormData(form);
      const addons = customizerAddons(form);
      const quantity = Math.max(1, Number(formData.get('quantity') || 1));
      const configurationId = formData.get('properties[_bp_configuration_id]') || crypto.randomUUID();
      if (addons.length) formData.set('properties[_bp_configuration_id]', configurationId);
      const baseVariantId = Number(formData.get('id'));
      const addUrl = form.dataset.cartAddUrl.replace(/\.js$/, '') + '.js';
      const cartUrl = form.dataset.cartUrl;
      const hasFile = [...form.querySelectorAll('input[type="file"]')]
        .some((input) => !input.disabled && input.files?.length);

      if (error) error.hidden = true;
      if (button) {
        button.disabled = true;
        button.textContent = button.dataset.addingLabel;
      }

      try {
        if (isCartPreview) {
          const previewResponse = await fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          });
          const previewItem = await previewResponse.json();
          if (!previewResponse.ok) throw new Error(previewItem.description || previewItem.message || 'Design preview could not be added');
          window.location.assign(cartUrl);
          return;
        }
        if (hasFile) {
          const baseResponse = await fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          });
          const baseItem = await baseResponse.json();
          if (!baseResponse.ok) throw new Error(baseItem.description || baseItem.message || 'Base item could not be added');

          if (addons.length) {
            const addonResponse = await fetch(addUrl, {
              method: 'POST',
              headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: addons.map((addon) => ({
                  id: addon.id,
                  quantity,
                  properties: {
                    _bp_configuration_id: configurationId,
                    _customization_for: form.dataset.productTitle,
                    _base_variant: String(baseVariantId),
                    _customization_label: addon.label
                  }
                }))
              })
            });
            if (!addonResponse.ok) {
              if (baseItem.key) {
                await fetch(cartUrl + '/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: baseItem.key, quantity: 0 })
                });
              }
              const addonError = await addonResponse.json();
              throw new Error(addonError.description || addonError.message || 'Customization could not be added');
            }
          }
        } else {
          const properties = {};
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && typeof value === 'string' && value) properties[match[1]] = value;
          }
          const items = [{
            id: baseVariantId,
            quantity,
            properties
          }, ...addons.map((addon) => ({
            id: addon.id,
            quantity,
            properties: {
              _bp_configuration_id: configurationId,
                    _customization_for: form.dataset.productTitle,
              _base_variant: String(baseVariantId),
              _customization_label: addon.label
            }
          }))];
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Configuration could not be added');
        }

        window.location.assign(cartUrl);
      } catch (submissionError) {
        if (error) {
          error.hidden = false;
          error.textContent = submissionError.message || error.textContent;
        }
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.addLabel;
        }
      }
    });
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog) dialog.showModal();
    }

    const closer = event.target.closest('[data-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
    }

    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const input = quantityButton.parentElement.querySelector('input[type="number"]');
      if (input) {
        const next = Number(input.value || 1) + Number(quantityButton.dataset.quantityChange);
        input.value = Math.max(Number(input.min || 0), next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const galleryButton = event.target.closest('[data-gallery-target]');
    if (galleryButton) {
      const gallery = galleryButton.closest('[data-product-gallery]');
      gallery.querySelectorAll('[data-gallery-image]').forEach((image) => {
        image.hidden = image.dataset.galleryImage !== galleryButton.dataset.galleryTarget;
      });
      gallery.querySelectorAll('[data-gallery-target]').forEach((button) => {
        button.setAttribute('aria-current', String(button === galleryButton));
      });
    }

    const filterTrigger = event.target.closest('[data-filter-trigger]');
    if (filterTrigger) {
      const sidebar = document.querySelector('[data-filter-sidebar]');
      if (sidebar) {
        sidebar.classList.toggle('is-open');
        filterTrigger.setAttribute('aria-expanded', String(sidebar.classList.contains('is-open')));
      }
    }
  });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-demo-color-swatch]');
    if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    const card = swatch.closest('.product-card');
    if (!card) return;
    const image = card.querySelector('.product-card__media img');
    if (image) {
      if (swatch.dataset.variantImage) {
        image.srcset = '';
        image.src = swatch.dataset.variantImage;
        image.alt = `${card.querySelector('.product-card__title')?.textContent?.trim() || 'Snowmobile graphics'} — ${swatch.title}`;
        image.style.filter = 'none';
      } else {
        image.style.filter = `hue-rotate(${Number(swatch.dataset.hueShift || 0)}deg)`;
      }
    }
    card.querySelectorAll('.product-card__media, .product-card__title a').forEach((link) => { link.href = swatch.href; });
    card.querySelectorAll('[data-demo-color-swatch]').forEach((choice) => {
      choice.classList.toggle('is-selected', choice === swatch);
      if (choice === swatch) choice.setAttribute('aria-current', 'true');
      else choice.removeAttribute('aria-current');
    });
  });

  const syncProductVariant = (select, updateUrl = true) => {
    const option = select.selectedOptions[0];
    const root = select.closest('[data-product-root]');
    if (!root || !option) return;
    const price = root.querySelector('[data-product-price]');
    const button = root.querySelector('[data-add-button]');
    const hasPricedCustomizer = Boolean(root.querySelector('.bp-customizer'));
    if (price && option.dataset.price && !hasPricedCustomizer) price.textContent = option.dataset.price;
    if (button) {
      button.disabled = option.dataset.available !== 'true';
      button.textContent = option.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldLabel;
    }
    if (root.dataset.designBaseHue !== undefined) {
      const hue = { red: 0, blue: 205, green: 95, purple: 275 }[String(option.dataset.color || '').toLowerCase()] ?? 0;
      root.style.setProperty('--preview-hue-shift', `${hue - Number(root.dataset.designBaseHue)}deg`);
    }

    const gallery = root.querySelector('[data-product-gallery]');
    if (gallery) {
      const images = [...gallery.querySelectorAll('[data-gallery-image]')];
      const currentImage = images.find((image) => image.dataset.galleryImage === option.dataset.mediaId) || images[0];
      if (currentImage) {
        images.forEach((image) => { image.hidden = image !== currentImage; });
        gallery.querySelectorAll('[data-gallery-target]').forEach((thumb) => {
          thumb.setAttribute('aria-current', String(thumb.dataset.galleryTarget === currentImage.dataset.galleryImage));
        });
      }
    }

    if (updateUrl && history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    }
  };

  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-gallery-variant]');
    if (!choice || choice.disabled) return;
    const select = choice.closest('[data-product-root]')?.querySelector('[data-variant-select]');
    if (!select) return;
    select.value = choice.dataset.galleryVariant;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-collection-tag-select]')) {
      const destination = new URL(event.target.value, window.location.origin);
      destination.search = window.location.search;
      destination.searchParams.delete('page');
      window.location.assign(destination);
    }
    if (event.target.matches('[data-sort-select]')) event.target.form.submit();

    if (event.target.matches('[data-variant-select]')) {
      syncProductVariant(event.target);
    }
  });

  document.querySelectorAll('[data-product-root] [data-variant-select]').forEach((select) => syncProductVariant(select, false));

  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["snow-older-model-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const unique = values => [...new Set(values)];
    const option = (value, label) => {
      const element = document.createElement('option');
      element.value = String(value);
      element.textContent = label;
      return element;
    };
    const boot = (scope = document) => {
      const roots = [...scope.querySelectorAll('[data-bp-older-picker]')];
      if (scope.matches?.('[data-bp-older-picker]')) roots.unshift(scope);
      roots.forEach(async root => {
      if (root.dataset.olderPickerState === 'loading' || root.dataset.olderPickerState === 'ready') return;
      root.dataset.olderPickerState = 'loading';
      const form = root.querySelector('[data-bp-older-form]');
      const makeSelect = root.querySelector('[data-bp-older-make]');
      const year = root.querySelector('[data-bp-older-year]');
      const model = root.querySelector('[data-bp-older-model]');
      const track = root.querySelector('[data-bp-older-track]');
      const trackField = root.querySelector('[data-bp-older-track-field]');
      const request = root.querySelector('[data-request-form]');
      const selectionSummary = root.querySelector('[data-selection-summary]');
      const contactFields = Object.fromEntries([...root.querySelectorAll('[data-contact-field]')].map(input => [input.dataset.contactField,input]));
      const upload = root.querySelector('[data-request-upload]');
      const uploadName = root.querySelector('[data-upload-name]');
      const status = root.querySelector('[data-bp-older-status]');
      const retry = root.querySelector('[data-bp-older-retry]');
      const script = root.querySelector('[data-machine-data]');
      let modernDesigns = JSON.parse(root.querySelector('[data-modern-designs]')?.textContent || '[]');
      let indexPromise, fitmentPromise;
      const getFitment = () => fitmentPromise ||= new Promise((resolve,reject) => {
        let timer;
        const script=root.querySelector('script[src*="bp-snow-fitment.js"]');
        const cleanup=()=>{clearTimeout(timer);script?.removeEventListener('load',ready);script?.removeEventListener('error',failed);};
        const ready=()=>{cleanup();if(window.BPSnowFitmentReady)Promise.resolve(window.BPSnowFitmentReady).then(resolve,reject);else reject(new Error('Fitment script did not initialize'));};
        const failed=()=>{cleanup();reject(new Error('Fitment script unavailable'));};
        if(window.BPSnowFitmentReady){ready();return;}
        script?.addEventListener('load',ready,{once:true});
        script?.addEventListener('error',failed,{once:true});
        timer=setTimeout(failed,15000);
      }).catch(error=>{fitmentPromise=null;throw error;});
      const loadModernIndex = () => indexPromise ||= (async () => {
        const fitment = await getFitment();
        modernDesigns = await fitment.loadDesignIndex(root);
      })().catch(error => { indexPromise = null; throw error; });
      const collator = new Intl.Collator(document.documentElement.lang || 'en', { numeric:true, sensitivity:'base' });
      const placeholders = { year:year.options[0].textContent, model:model.options[0].textContent, track:track.options[0].textContent };
      let catalog, makeIndex, categoryIndex, categoryRows = [], makeRows = [], restoring = false, lookupSerial = 0;
      const invalidateLookup = () => {
        lookupSerial += 1;
        root.removeAttribute('aria-busy');
      };
      const fill = (select, placeholder, entries) => {
        select.replaceChildren(option('', placeholder));
        entries.forEach(([value,label]) => select.append(option(value,label)));
        select.disabled = !entries.length;
        select.value = '';
      };
      const rowTrackSize = row => {
        const label = catalog.trims[row[4]] || '';
        const match = label.match(/(?:^|[^\d])(1[2-8]\d)\s*(?:"|″|''|in(?:ches)?\b)/i);
        return match ? match[1] : null;
      };
      const productTrackSize = handle => {
        const match = handle.match(/(?:tunnel|track)[-_ ]?(1[2-8]\d)(?:\b|$)|\b(1[2-8]\d)[-_ ]?(?:tunnel|track)(?:\b|$)/i);
        return match ? (match[1] || match[2]) : null;
      };
      const matchingRows = () => makeRows.filter(row => row[2] === year.value && row[3] === Number(model.value));
      const trackSizes = () => unique(matchingRows().flatMap(row => {
        const size = rowTrackSize(row);
        return size ? [size] : row[5].map(index => productTrackSize(catalog.products[index])).filter(Boolean);
      })).sort((a,b) => Number(a)-Number(b));
      const matchHandles = () => {
        const rows = matchingRows().filter(row => !track.value || !rowTrackSize(row) || rowTrackSize(row) === track.value);
        return unique(rows.flatMap(row => row[5])).filter(index => {
          const size = productTrackSize(catalog.products[index]);
          return !track.value || !size || size === track.value;
        }).map(index => catalog.products[index]).filter(handle => !(catalog.modern_products || []).includes(handle));
      };
      const resetTrack = () => {
        fill(track, placeholders.track, []);
        track.required = false;
        trackField.hidden = true;
      };
      const hideRequest = () => {
        if (!request.querySelector('.machine-finder__form-message')) request.hidden = true;
      };
      const vintageOnly = root.dataset.vintageOnly === 'true';
      const selectedMake = () => catalog.makes[makeIndex] || root.dataset.olderMake || '';
      const selectedCategory = () => root.dataset.olderCategoryLabel || catalog.categories[categoryIndex].label;
      const selectedModel = () => model.value === 'not-listed' ? root.dataset.unlisted : catalog.models[Number(model.value)];
      const showRequest = () => {
        const values = {
          category:selectedCategory(),
          make:selectedMake(),
          year:year.value,
          model:selectedModel(),
          track:track.value && track.value !== 'not-sure' ? track.value + '″' : ''
        };
        Object.entries(values).forEach(([key,value]) => {
          if (contactFields[key]) contactFields[key].value = value;
        });
        selectionSummary.textContent = Object.values(values).filter(Boolean).join(' / ');
        request.hidden = false;
        status.textContent = root.dataset.noMatch;
        if (!restoring) request.scrollIntoView({behavior:'smooth',block:'nearest'});
      };
      const navigate = async () => {
        if (restoring || !year.value || !model.value || (model.value !== 'not-listed' && !trackField.hidden && !track.value)) return;
        if (model.value === 'not-listed') {
          showRequest();
          return;
        }
        const lookup = ++lookupSerial;
        root.setAttribute('aria-busy','true');
        status.textContent = root.dataset.matchesLoading;
        const fitment = await getFitment().catch(() => null);
        if (lookup !== lookupSerial) return;
        if(!vintageOnly){try{await loadModernIndex();}catch(error){if(lookup===lookupSerial){root.removeAttribute('aria-busy');showRequest();status.textContent=root.dataset.checkError;}return;}}
        if(lookup!==lookupSerial)return;
        const eligibleDesigns = root.dataset.fitmentGroup ? modernDesigns.filter(design => design.tags.includes('fitgroup-' + root.dataset.fitmentGroup)) : modernDesigns;
        const modern=!vintageOnly ? fitment?.matchCatalogDesigns(eligibleDesigns, root.dataset.olderCategory, selectedMake(), year.value, selectedModel(), trackField.hidden ? '' : track.value) || {handles:[],model:''} : {handles:[],model:''};
        const handles = unique([...modern.handles, ...matchHandles()]);
        if (!handles.length) {
          root.removeAttribute('aria-busy');
          showRequest();
          return;
        }
        const base = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
        const checked = await Promise.allSettled(handles.map(async handle => {
          const response = await fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { headers:{ Accept:'application/json' } });
          if (response.status === 404) return null;
          if (!response.ok) throw new Error('Product lookup unavailable');
          const product = await response.json();
          const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
          const unpreparedTemplate = root.dataset.olderCategory === 'snowmobile' && Number(year.value) < 2011
            && tags.some(tag => tag.trim().toLowerCase() === 'template-purchasable');
          const verifiedVintage = !vintageOnly || tags.some(tag => tag.trim().toLowerCase() === 'vintage');
          return product.handle === handle && product.available && !tags.includes('not-for-sale') && !unpreparedTemplate && verifiedVintage ? handle : null;
        }));
        if (lookup !== lookupSerial) return;
        root.removeAttribute('aria-busy');
        const available = checked.filter(item => item.status === 'fulfilled' && item.value).map(item => item.value);
        if (!available.length) {
          if (checked.some(item => item.status === 'rejected')) status.textContent = root.dataset.checkError;
          else showRequest();
          return;
        }
        const params = new URLSearchParams({
          category:selectedCategory(),
          category_key:root.dataset.olderCategory,
          make:selectedMake(),
          year:year.value,
          model:selectedModel(),
          track_size:trackField.hidden ? '' : track.value,
          products:available.join(','),
          source:root.dataset.olderCategory === 'snowmobile' && !modern.handles.length ? 'older' : 'collection',
          source_collection:root.dataset.sourceCollection
        });
        if (modern.handles.length && modern.model) params.set('modern_model', modern.model);
        const previewId = root.dataset.previewThemeId || new URLSearchParams(location.search).get('preview_theme_id');
        if (previewId) params.set('preview_theme_id',previewId);
        location.assign(root.dataset.resultsUrl + '?' + params.toString());
      };
      const populateYears = () => {
        makeRows = categoryRows.filter(row => row[1] === makeIndex);
        const availableRows = makeRows.length || makeSelect ? makeRows : categoryRows;
        const years = unique(availableRows.map(row => row[2])).sort((a,b) => {
          if (a === 'Current') return -1;
          if (b === 'Current') return 1;
          return Number(b)-Number(a);
        });
        fill(year, placeholders.year, years.map(value => [value,value]));
        fill(model, placeholders.model, []);
        resetTrack();
        hideRequest();
        status.textContent = '';
        return years;
      };
      if (makeSelect) makeSelect.addEventListener('change', () => {
        invalidateLookup();
        makeIndex = makeSelect.value === '' ? -1 : Number(makeSelect.value);
        populateYears();
      });
      year.addEventListener('change', () => {
        invalidateLookup();
        fill(model, placeholders.model, []);
        resetTrack();
        hideRequest();
        status.textContent = '';
        if (year.value) {
          const indexes = unique(makeRows.filter(row => row[2] === year.value).map(row => row[3]))
            .sort((a,b) => collator.compare(catalog.models[a],catalog.models[b]));
          fill(model, placeholders.model, indexes.map(index => [index,catalog.models[index]]).concat([['not-listed',root.dataset.unlisted]]));
        }
      });
      model.addEventListener('change', () => {
        invalidateLookup();
        resetTrack();
        hideRequest();
        status.textContent = '';
        if (!model.value) return;
        if (model.value === 'not-listed') {
          showRequest();
          if (!restoring) root.querySelector('[name="contact[Unlisted model]"]')?.focus({preventScroll:true});
          return;
        }
        const sizes = trackSizes();
        if (sizes.length) {
          fill(track, placeholders.track, sizes.map(size => [size,size + '″']));
          track.required = true;
          trackField.hidden = false;
        } else navigate();
      });
      track.addEventListener('change', () => {
        invalidateLookup();
        hideRequest();
        if (model.value !== 'not-listed' && track.value) navigate();
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (form.reportValidity()) navigate();
      });
      try {
        if (!('DecompressionStream' in window)) throw new Error('Catalog decompression unavailable');
        const binary = atob(script.textContent.trim());
        const bytes = Uint8Array.from(binary, character => character.charCodeAt(0));
        catalog = JSON.parse(await new Response(new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'))).text());
        if (root.dataset.olderCategory === 'snowmobile') {
          try {
            const vintageProducts = await window.BPVintageCatalog.load(root);
            catalog = window.BPVintageCatalog.enrich(catalog, vintageProducts, vintageOnly);
          } catch (error) {
            if (vintageOnly) throw error;
            console.warn('Published vintage index unavailable', error);
          }
        }
        const sledFitment=await getFitment();
        if(!vintageOnly&&sledFitment?.enrichCatalog){
          // Populate choices from the same published records used for matching.
          // Keep the bundled selector usable if the network check fails; retry
          // the index when the customer requests matches.
          try{await loadModernIndex();}catch{}
          catalog=sledFitment.enrichCatalog(catalog,modernDesigns);
        }
        categoryIndex = catalog.categories.findIndex(item => item.key === root.dataset.olderCategory);
        if (categoryIndex < 0) throw new Error('Category unavailable');
        categoryRows = catalog.rows.filter(row => row[0] === categoryIndex);
        if (root.dataset.fitmentGroup && sledFitment) categoryRows = categoryRows.filter(row => {
          const make=catalog.makes[row[1]],model=catalog.models[row[3]],track=rowTrackSize(row);
          return sledFitment.match(make,row[2],model,track).groups.includes(root.dataset.fitmentGroup) ||
            sledFitment.matchDesigns(modernDesigns.filter(d=>d.tags.includes('fitgroup-'+root.dataset.fitmentGroup)),make,row[2],model,track).handles.length;
        });
        makeIndex = catalog.makes.indexOf(root.dataset.olderMake);
        if (makeSelect) {
          const indexes = unique(categoryRows.map(row => row[1]))
            .filter(index => catalog.makes[index] !== 'Digital Product')
            .sort((a,b) => collator.compare(catalog.makes[a],catalog.makes[b]));
          fill(makeSelect, makeSelect.options[0].textContent, indexes.map(index => [index,catalog.makes[index]]));
        }
        const saved = new URLSearchParams(location.search);
        const savedMake = saved.get('finder_make');
        if (makeSelect && savedMake) {
          const index = catalog.makes.indexOf(savedMake);
          if ([...makeSelect.options].some(item => item.value === String(index))) {
            makeSelect.value = String(index);
            makeIndex = index;
          }
        }
        const years = populateYears();
        const savedYear = saved.get('finder_year');
        if (years.includes(savedYear)) {
          restoring = true;
          year.value = savedYear;
          year.dispatchEvent(new Event('change'));
          const index = catalog.models.findIndex(value => value === saved.get('finder_model'));
          const savedModel = saved.get('finder_model');
          if (index >= 0 && [...model.options].some(item => item.value === String(index))) {
            model.value = String(index);
            model.dispatchEvent(new Event('change'));
          } else if (savedModel) {
            model.value = 'not-listed';
            root.querySelector('[name="contact[Unlisted model]"]').value = savedModel;
            model.dispatchEvent(new Event('change'));
          }
          const savedTrack = saved.get('finder_track_size');
          if ([...track.options].some(item => item.value === savedTrack)) track.value = savedTrack;
          restoring = false;
        }
        if (upload) upload.addEventListener('change', () => {
          const file = upload.files?.[0];
          if (!file) { uploadName.textContent = ''; return; }
          if (file.size > 10 * 1024 * 1024) {
            upload.value = '';
            uploadName.textContent = root.dataset.uploadTooLarge;
            return;
          }
          uploadName.textContent = file.name;
        });
        root.dataset.olderPickerState = 'ready';
        retry.hidden = true;
      } catch (error) {
        root.dataset.olderPickerState = 'error';
        status.textContent = root.dataset.catalogError;
        retry.hidden = false;
        console.error('Older model catalog initialization failed:', error);
      }
      retry.addEventListener('click', () => {
        root.dataset.olderPickerState = '';
        retry.hidden = true;
        status.textContent = 'Loading model years…';
        boot(root);
      }, { once:true });
    });
    };
    boot();
    document.addEventListener('shopify:section:load', event => boot(event.target));
    window.addEventListener('pageshow', () => boot());
  })();
  } catch(e) { console.error(e); }
})();

})();
